module.exports = __webpack_public_path__ + "img/wechat_download_tip.5b15117f.png";